import React from 'react'
import { FM } from '@divvy-web/i18n'

export const OK = 'ok'
export const ERROR = 'error'

export const statusMapping = {
  BLOCKED: { description: <FM msg='We have encountered issues attempting to connect with your bank account. Please contact support for assistance.' />, type: ERROR },
  CLOSED: { description: <FM msg="This institution's connection is closed. Please exit and try again. You may need to try another bank connector." />, type: ERROR },
  CONNECTED: { description: <FM msg='Working perfectly' />, type: OK },
  DISABLED: { description: <FM msg='Syncing has been disabled.' />, type: OK },
  FAILED: { description: <FM msg='Syncing failed, try again later.' />, type: ERROR },
  INVALID_CREDENTIALS: { description: <FM msg='The credentials are either invalid or have not been provided.' />, type: ERROR },
  NOT_SUPPORTED: { description: <FM msg='The institution is no longer supported.' />, type: ERROR },
  SYNCING: { description: <FM msg='The member is currently syncing.' />, type: OK }
}
